document.querySelectorAll('.cw-faq-question').forEach(button => {
  button.addEventListener('click', () => {
    // Toggle active class on button
    button.classList.toggle('active');

    // Get the associated answer
    const answer = button.nextElementSibling;
    answer.classList.toggle('active');

    // Close other answers
    document.querySelectorAll('.cw-faq-answer').forEach(item => {
      if (item !== answer) {
        item.classList.remove('active');
      }
    });

    // Close other buttons
    document.querySelectorAll('.cw-faq-question').forEach(item => {
      if (item !== button) {
        item.classList.remove('active');
      }
    });
  });
});

const accordionHeaders = document.querySelectorAll('.cw-accordion-header');

accordionHeaders.forEach(header => {
    header.addEventListener('click', () => {
        // Get the associated accordion content
        const content = header.nextElementSibling;

        // Toggle the 'show' class to expand or collapse the content
        content.classList.toggle('show');

        // Toggle the '+' and '-' sign in the icon
        const icon = header.querySelector('.cw-accordion-icon');
        icon.textContent = content.classList.contains('show') ? '-' : '+';
    });
});


setTimeout(function() {
  const swiperclient = new Swiper('.happy-client-swiper', {
    direction: 'horizontal',
    loop: true,
      slidesPerView: 1,
      spaceBetween: 10,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true, 
    },
    breakpoints: {
  
      1024: {
        slidesPerView: 3.4, 
        spaceBetween: 20
      },
     
      768: {
        slidesPerView: 2,
        spaceBetween: 20
      },

      0: {
        slidesPerView: 1,
        spaceBetween: 10
      }
    }
  });
  
}, 1000);







document.addEventListener("DOMContentLoaded", () => {
  const sliderContainer = document.querySelector(".slider-container");
  const afterImage = document.querySelector(".after");
  const sliderHandle = document.querySelector(".slider-handle");

  let isDragging = false;

  const dragHandler = (e) => {
    if (!isDragging) return;

    const sliderRect = sliderContainer.getBoundingClientRect();
    let x = e.pageX - sliderRect.left;

    // Restrict movement within slider bounds
    if (x < 0) x = 0;
    if (x > sliderRect.width) x = sliderRect.width;

    // Update the slider handle position
    sliderHandle.style.left = `${(x / sliderRect.width) * 100}%`;

    // Update the clip-path of the after image
    afterImage.style.clipPath = `inset(0 ${100 - (x / sliderRect.width) * 100}% 0 0)`;
  };

  sliderHandle.addEventListener("mousedown", () => (isDragging = true));
  window.addEventListener("mousemove", dragHandler);
  window.addEventListener("mouseup", () => (isDragging = false));

  // Handle touch events for mobile
  sliderHandle.addEventListener("touchstart", () => (isDragging = true));
  window.addEventListener("touchmove", (e) => {
    const touch = e.touches[0];
    dragHandler(touch);
  });
  window.addEventListener("touchend", () => (isDragging = false));
});

